import { LDSSkeleton } from "@resmed/lumina-design-system";

/** Placeholder row that mirrors ParticipantListItem with the checkbox variant. */
const SkeletonParticipantListItem = () => (
  <div className="lds-flex lds-items-center lds-gap-3 lds-rounded-lg lds-border lds-border-bordercolor-default lds-bg-white lds-p-3">
    <LDSSkeleton shape="rectangle" width="1.125rem" height="1.125rem" borderRadius="0.25rem" />
    <LDSSkeleton shape="circle" width="2.5rem" height="2.5rem" />
    <div className="lds-flex lds-flex-col lds-flex-1 lds-min-w-0 lds-gap-2">
      <LDSSkeleton shape="rectangle" width="55%" height="0.875rem" />
      <LDSSkeleton shape="rectangle" width="32%" height="0.75rem" />
    </div>
  </div>
);

/** Stack of skeleton participant rows rendered while the API is loading. */
export const SkeletonParticipantList = ({ count = 7 }: { count?: number }) => (
  <div className="lds-space-y-2">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonParticipantListItem key={i} />
    ))}
  </div>
);

export default SkeletonParticipantListItem;
